import React, { createContext, useContext, useState, ReactNode } from 'react';

interface LoginModalContextType {
  isLoginModalActive: boolean;
  setLoginModalActive: (active: boolean) => void;
}

const LoginModalContext = createContext<LoginModalContextType | undefined>(undefined);

interface LoginModalProviderProps {
  children: ReactNode;
}

export const LoginModalProvider: React.FC<LoginModalProviderProps> = ({ children }) => {
  const [isLoginModalActive, setIsLoginModalActive] = useState(false);

  const setLoginModalActive = (active: boolean) => {
    setIsLoginModalActive(active);
  };

  return (
    <LoginModalContext.Provider value={{ isLoginModalActive, setLoginModalActive }}>
      {children}
    </LoginModalContext.Provider>
  );
};

export const useLoginModalContext = () => {
  const context = useContext(LoginModalContext);
  if (context === undefined) {
    throw new Error('useLoginModalContext must be used within a LoginModalProvider');
  }
  return context;
};
